(ns nosco.icons2
  (:require
   [clojure.string :as string]
   [hx.react :as hx :refer [defnc]]
   [nosco.placeholders :as placeholders]
   [nosco.react :as nosco-react]
   [nosco.ui.html]
   [shadow.resource :as rc])
  (:require-macros [nosco.icons2]
                   [nosco.figma-utils]))

;; get the svg as a big string -- shadow.cljs makes sure to
;; refresh the build when the file changes to get hot reloading
(def raw-svg-source (rc/inline "icons2.svg"))

(def nosco-logo (rc/inline "public/main/img/nosco-logo.svg"))

(defnc NoscoLogo [{:keys [style class]}]
  [nosco.ui.html/UnsafeHTML {:style style
                             :class class
                             :html nosco-logo}])

;; load this element ONCE in the file, the huge svg is hidden
(defnc MainSVG []
  [nosco.ui.html/UnsafeHTML {:style {:display "none"}
                             :html raw-svg-source}])

(def xsmall-ids (nosco.icons2/inline-icon-ids :xsmall))
(def small-ids (nosco.icons2/inline-icon-ids :small))
(def large-ids (nosco.icons2/inline-icon-ids :large))

(defn stem [icon-str]
  (cond (string/starts-with? icon-str "12px-Xsmall") (subs icon-str (count "12px-Xsmall"))
        (string/starts-with? icon-str "16px-Small") (subs icon-str (count "16px-Small"))
        (string/starts-with? icon-str "24px-Large") (subs icon-str (count "24px-Large"))))

(defn ->xsmall [icon-str]
  (str "12px-Xsmall" (stem icon-str)))

(defn ->small [icon-str]
  (str "16px-Small" (stem icon-str)))

#_{:clojure-lsp/ignore [:clojure-lsp/unused-public-var]}
(defn ->large [icon-str]
  (str "24px-Large" (stem icon-str)))

;; We cannot use a "style" property because hx converts it to a js object
;; It seems like a bug in hx?
;; We will use the "icon-style" property instead until hx is fixed
(defnc Icon [{:keys [icon icon-style color] :as props}]
  (let [href (str "#" (string/trim (name icon)))
        style (cond
                (get xsmall-ids icon) {:width "12px"
                                       :height "12px"}
                (get small-ids icon) {:width "16px"
                                      :height "16px"}
                (get large-ids icon) {:width "24px"
                                      :height "24px"})
        style (if color (merge style {:fill color}) style)
        style (merge style icon-style)]
    [:svg
     (-> {:class "nosco-icon"
          :aria-label (name icon)
          :style style}
         (nosco-react/merge-props (dissoc props :icon :style :icon-style :color)))
     [:use {:href href :xlinkHref href}]]))

(defnc IconOnGrayCircle [{:keys [icon]}]
  [:div {:class "nosco-icons-icon-on-gray-circle"}
   [Icon {:icon icon}]])

(defnc LoadingIcon
  "An SVG icon that can be spinned without artifacts. You need to apply your own
   spinning animation and positioning on top. An explicit color is required."
  [{:keys [size color] :as props
    :or {size :small}}]
  (let [circles {:small {:cx 8 :cy 8 :r 6 :stroke color :stroke-width 1.85 :fill "transparent"}
                 :large {:cx 12 :cy 12 :r 8 :stroke color :stroke-width 2 :fill "transparent"}}]
    [:svg (-> {:class "nosco-icon"
               :aria-label "Loading"
               :style (cond-> {}
                        (= size :large) (merge {:width "24px" :height "24px"})
                        (= size :small) (merge {:width "16px" :height "16px"}))}
              (nosco-react/merge-props (dissoc props :color :size)))
     [:circle (assoc (get circles size) :stroke-dasharray "56.66% 100")]
     [:circle (assoc (get circles size) :opacity "0.4")]]))

(defnc PlaceholderImage [{:keys [variant id] :as props}]
  ;; NOTE keeping the variant argument if we ever want to
  ;; differentiate the placeholder images based on type
  ;; but for now we only have one variant that is responsive
  (case variant
    (:idea-list :idea-card :channel)
    [placeholders/Placeholder (nosco-react/merge-props
                               {:idx (placeholders/variant-idx id)}
                               (dissoc props :variant))]))

#_{:clojure-lsp/ignore [:clojure-lsp/unused-public-var]}
;; == DO NOT EDIT -- AUTOMATICALLY GENERATED ===================================
;; To update, run `bb update-icons`
(nosco.figma-utils/defmap _
  {AI-large "24px-LargeAI",
   AI-small "16px-SmallAI",
   AI-xsmall "12px-XsmallAI",
   Access-large "24px-LargeAccess",
   Access-small "16px-SmallAccess",
   Access-xsmall "12px-XsmallAccess",
   Active-large "24px-LargeActive",
   Active-small "16px-SmallActive",
   Active-xsmall "12px-XsmallActive",
   Activity-large "24px-LargeActivity",
   Activity-small "16px-SmallActivity",
   Activity-xsmall "12px-XsmallActivity",
   Add-large "24px-LargeAdd",
   Add-small "16px-SmallAdd",
   Add-xsmall "12px-XsmallAdd",
   AddAbove-large "24px-LargeAddAbove",
   AddAbove-small "16px-SmallAddAbove",
   AddAbove-xsmall "12px-XsmallAddAbove",
   AddBelow-large "24px-LargeAddBelow",
   AddBelow-small "16px-SmallAddBelow",
   AddBelow-xsmall "12px-XsmallAddBelow",
   AddComment-large "24px-LargeAddComment",
   AddComment-small "16px-SmallAddComment",
   AddComment-xsmall "12px-XsmallAddComment",
   AddNote-large "24px-LargeAddNote",
   AddNote-small "16px-SmallAddNote",
   AddNote-xsmall "12px-XsmallAddNote",
   AddUser-large "24px-LargeAddUser",
   AddUser-small "16px-SmallAddUser",
   AddUser-xsmall "12px-XsmallAddUser",
   Admin-large "24px-LargeAdmin",
   Admin-small "16px-SmallAdmin",
   Admin-xsmall "12px-XsmallAdmin",
   Alarm-large "24px-LargeAlarm",
   Alarm-small "16px-SmallAlarm",
   Alarm-xsmall "12px-XsmallAlarm",
   AlignCenter-large "24px-LargeAlignCenter",
   AlignCenter-small "16px-SmallAlignCenter",
   AlignCenter-xsmall "12px-XsmallAlignCenter",
   AlignLeft-large "24px-LargeAlignLeft",
   AlignLeft-small "16px-SmallAlignLeft",
   AlignLeft-xsmall "12px-XsmallAlignLeft",
   AlignRight-large "24px-LargeAlignRight",
   AlignRight-small "16px-SmallAlignRight",
   AlignRight-xsmall "12px-XsmallAlignRight",
   Anonymous-large "24px-LargeAnonymous",
   Anonymous-small "16px-SmallAnonymous",
   Anonymous-xsmall "12px-XsmallAnonymous",
   Apps-large "24px-LargeApps",
   Apps-small "16px-SmallApps",
   Apps-xsmall "12px-XsmallApps",
   Archive-large "24px-LargeArchive",
   Archive-small "16px-SmallArchive",
   Archive-xsmall "12px-XsmallArchive",
   ArrowDown-large "24px-LargeArrowDown",
   ArrowDown-small "16px-SmallArrowDown",
   ArrowDown-xsmall "12px-XsmallArrowDown",
   ArrowLeft-large "24px-LargeArrowLeft",
   ArrowLeft-small "16px-SmallArrowLeft",
   ArrowLeft-xsmall "12px-XsmallArrowLeft",
   ArrowRight-large "24px-LargeArrowRight",
   ArrowRight-small "16px-SmallArrowRight",
   ArrowRight-xsmall "12px-XsmallArrowRight",
   ArrowUp-large "24px-LargeArrowUp",
   ArrowUp-small "16px-SmallArrowUp",
   ArrowUp-xsmall "12px-XsmallArrowUp",
   Assignment-large "24px-LargeAssignment",
   Assignment-small "16px-SmallAssignment",
   Assignment-xsmall "12px-XsmallAssignment",
   Asterisk-large "24px-LargeAsterisk",
   Asterisk-small "16px-SmallAsterisk",
   Asterisk-xsmall "12px-XsmallAsterisk",
   AtSign-large "24px-LargeAtSign",
   AtSign-small "16px-SmallAtSign",
   AtSign-xsmall "12px-XsmallAtSign",
   Attach-large "24px-LargeAttach",
   Attach-small "16px-SmallAttach",
   Attach-xsmall "12px-XsmallAttach",
   Award-large "24px-LargeAward",
   Award-small "16px-SmallAward",
   Award-xsmall "12px-XsmallAward",
   Ban-large "24px-LargeBan",
   Ban-small "16px-SmallBan",
   Ban-xsmall "12px-XsmallBan",
   Bookmark-large "24px-LargeBookmark",
   Bookmark-small "16px-SmallBookmark",
   Bookmark-xsmall "12px-XsmallBookmark",
   Brush-large "24px-LargeBrush",
   Brush-small "16px-SmallBrush",
   Brush-xsmall "12px-XsmallBrush",
   BubbleChart-large "24px-LargeBubbleChart",
   BubbleChart-small "16px-SmallBubbleChart",
   BubbleChart-xsmall "12px-XsmallBubbleChart",
   Buy-large "24px-LargeBuy",
   Buy-small "16px-SmallBuy",
   Buy-xsmall "12px-XsmallBuy",
   Calendar-large "24px-LargeCalendar",
   Calendar-small "16px-SmallCalendar",
   Calendar-xsmall "12px-XsmallCalendar",
   CallOut-large "24px-LargeCallOut",
   CallOut-small "16px-SmallCallOut",
   CallOut-xsmall "12px-XsmallCallOut",
   Camera-large "24px-LargeCamera",
   Camera-small "16px-SmallCamera",
   Camera-xsmall "12px-XsmallCamera",
   CardView-large "24px-LargeCardView",
   CardView-small "16px-SmallCardView",
   CardView-xsmall "12px-XsmallCardView",
   Categories-large "24px-LargeCategories",
   Categories-small "16px-SmallCategories",
   Categories-xsmall "12px-XsmallCategories",
   CategoriesNew-small "16px-SmallCategoriesNew",
   CategoriesNew-xsmall "12px-XsmallCategoriesNew",
   CategoryNew-large "24px-LargeCategoryNew",
   Channels-large "24px-LargeChannels",
   Channels-small "16px-SmallChannels",
   Channels-xsmall "12px-XsmallChannels",
   ChartBar-large "24px-LargeChartBar",
   ChartBar-small "16px-SmallChartBar",
   ChartBar-xsmall "12px-XsmallChartBar",
   ChartLine-large "24px-LargeChartLine",
   ChartLine-small "16px-SmallChartLine",
   ChartLine-xsmall "12px-XsmallChartLine",
   ChartPie-large "24px-LargeChartPie",
   ChartPie-small "16px-SmallChartPie",
   ChartPie-xsmall "12px-XsmallChartPie",
   Chat-large "24px-LargeChat",
   Chat-small "16px-SmallChat",
   Chat-xsmall "12px-XsmallChat",
   ChatAddOn-large "24px-LargeChatAddOn",
   ChatAddOn-small "16px-SmallChatAddOn",
   ChatAddOn-xsmall "12px-XsmallChatAddOn",
   Check-large "24px-LargeCheck",
   Check-small "16px-SmallCheck",
   Check-xsmall "12px-XsmallCheck",
   CheckFilled-large "24px-LargeCheckFilled",
   CheckFilled-small "16px-SmallCheckFilled",
   CheckFilled-xsmall "12px-XsmallCheckFilled",
   CheckLarge-large "24px-LargeCheckLarge",
   CheckLarge-small "16px-SmallCheckLarge",
   CheckLarge-xsmall "12px-XsmallCheckLarge",
   CheckList-large "24px-LargeCheckList",
   CheckList-small "16px-SmallCheckList",
   CheckList-xsmall "12px-XsmallCheckList",
   CheckSmall-large "24px-LargeCheckSmall",
   CheckSmall-small "16px-SmallCheckSmall",
   CheckSmall-xsmall "12px-XsmallCheckSmall",
   ChevronBack-large "24px-LargeChevronBack",
   ChevronBack-small "16px-SmallChevronBack",
   ChevronBack-xsmall "12px-XsmallChevronBack",
   ChevronDown-large "24px-LargeChevronDown",
   ChevronDown-small "16px-SmallChevronDown",
   ChevronDown-xsmall "12px-XsmallChevronDown",
   ChevronForward-large "24px-LargeChevronForward",
   ChevronForward-small "16px-SmallChevronForward",
   ChevronForward-xsmall "12px-XsmallChevronForward",
   ChevronLeft-large "24px-LargeChevronLeft",
   ChevronLeft-small "16px-SmallChevronLeft",
   ChevronLeft-xsmall "12px-XsmallChevronLeft",
   ChevronRight-large "24px-LargeChevronRight",
   ChevronRight-small "16px-SmallChevronRight",
   ChevronRight-xsmall "12px-XsmallChevronRight",
   ChevronUp-large "24px-LargeChevronUp",
   ChevronUp-small "16px-SmallChevronUp",
   ChevronUp-xsmall "12px-XsmallChevronUp",
   CircleCombined-large "24px-LargeCircleCombined",
   CircleCombined-small "16px-SmallCircleCombined",
   CircleCombined-xsmall "12px-XsmallCircleCombined",
   CircleFull-large "24px-LargeCircleFull",
   CircleFull-small "16px-SmallCircleFull",
   CircleFull-xsmall "12px-XsmallCircleFull",
   CircleOutline-large "24px-LargeCircleOutline",
   CircleOutline-small "16px-SmallCircleOutline",
   CircleOutline-xsmall "12px-XsmallCircleOutline",
   Clock-large "24px-LargeClock",
   Clock-small "16px-SmallClock",
   Clock-xsmall "12px-XsmallClock",
   Close-large "24px-LargeClose",
   Close-small "16px-SmallClose",
   Close-xsmall "12px-XsmallClose",
   CloseSmall-small "16px-SmallCloseSmall",
   CloseSmall-xsmall "12px-XsmallCloseSmall",
   CloudDone-large "24px-LargeCloudDone",
   CloudDone-small "16px-SmallCloudDone",
   CloudDone-xsmall "12px-XsmallCloudDone",
   CloudOff-large "24px-LargeCloudOff",
   CloudOff-small "16px-SmallCloudOff",
   CloudOff-xsmall "12px-XsmallCloudOff",
   Code-large "24px-LargeCode",
   Code-small "16px-SmallCode",
   Code-xsmall "12px-XsmallCode",
   Collapse-large "24px-LargeCollapse",
   Collapse-small "16px-SmallCollapse",
   Collapse-xsmall "12px-XsmallCollapse",
   Colour-large "24px-LargeColour",
   Colour-small "16px-SmallColour",
   Colour-xsmall "12px-XsmallColour",
   ColourFill-large "24px-LargeColourFill",
   ColourFill-small "16px-SmallColourFill",
   ColourFill-xsmall "12px-XsmallColourFill",
   ColourPicker-large "24px-LargeColourPicker",
   ColourPicker-small "16px-SmallColourPicker",
   ColourPicker-xsmall "12px-XsmallColourPicker",
   ColourReset-large "24px-LargeColourReset",
   ColourReset-small "16px-SmallColourReset",
   ColourReset-xsmall "12px-XsmallColourReset",
   Comment-large "24px-LargeComment",
   Comment-small "16px-SmallComment",
   Comment-xsmall "12px-XsmallComment",
   Company-large "24px-LargeCompany",
   Company-small "16px-SmallCompany",
   Company-xsmall "12px-XsmallCompany",
   Conditional-large "24px-LargeConditional",
   Conditional-small "16px-SmallConditional",
   Conditional-xsmall "12px-XsmallConditional",
   Contact-large "24px-LargeContact",
   Contact-small "16px-SmallContact",
   Contact-xsmall "12px-XsmallContact",
   Create-large "24px-LargeCreate",
   Create-small "16px-SmallCreate",
   Create-xsmall "12px-XsmallCreate",
   Dash-large "24px-LargeDash",
   Dash-small "16px-SmallDash",
   Dash-xsmall "12px-XsmallDash",
   Dashboard-large "24px-LargeDashboard",
   Dashboard-small "16px-SmallDashboard",
   Dashboard-xsmall "12px-XsmallDashboard",
   Database-large "24px-LargeDatabase",
   Database-small "16px-SmallDatabase",
   Database-xsmall "12px-XsmallDatabase",
   Delete-large "24px-LargeDelete",
   Delete-small "16px-SmallDelete",
   Delete-xsmall "12px-XsmallDelete",
   Dependency-large "24px-LargeDependency",
   Dependency-small "16px-SmallDependency",
   Dependency-xsmall "12px-XsmallDependency",
   Desktop-large "24px-LargeDesktop",
   Desktop-small "16px-SmallDesktop",
   Desktop-xsmall "12px-XsmallDesktop",
   DockToBottom-large "24px-LargeDockToBottom",
   DockToBottom-small "16px-SmallDockToBottom",
   DockToBottom-xsmall "12px-XsmallDockToBottom",
   DockToLeft-large "24px-LargeDockToLeft",
   DockToLeft-small "16px-SmallDockToLeft",
   DockToLeft-xsmall "12px-XsmallDockToLeft",
   DockToRight-large "24px-LargeDockToRight",
   DockToRight-small "16px-SmallDockToRight",
   DockToRight-xsmall "12px-XsmallDockToRight",
   DocumentCopy-large "24px-LargeDocumentCopy",
   DocumentCopy-small "16px-SmallDocumentCopy",
   DocumentCopy-xsmall "12px-XsmallDocumentCopy",
   DocumentSearch-large "24px-LargeDocumentSearch",
   DocumentSearch-small "16px-SmallDocumentSearch",
   DocumentSearch-xsmall "12px-XsmallDocumentSearch",
   Done-large "24px-LargeDone",
   Done-small "16px-SmallDone",
   Done-xsmall "12px-XsmallDone",
   DoubleArrowLeft-large "24px-LargeDoubleArrowLeft",
   DoubleArrowLeft-small "16px-SmallDoubleArrowLeft",
   DoubleArrowLeft-xsmall "12px-XsmallDoubleArrowLeft",
   DoubleArrowRight-large "24px-LargeDoubleArrowRight",
   DoubleArrowRight-small "16px-SmallDoubleArrowRight",
   DoubleArrowRight-xsmall "12px-XsmallDoubleArrowRight",
   Download-large "24px-LargeDownload",
   Download-small "16px-SmallDownload",
   Download-xsmall "12px-XsmallDownload",
   Drag-large "24px-LargeDrag",
   Drag-small "16px-SmallDrag",
   Drag-xsmall "12px-XsmallDrag",
   DragArrows-large "24px-LargeDragArrows",
   DragArrows-small "16px-SmallDragArrows",
   DragArrows-xsmall "12px-XsmallDragArrows",
   DropdownLarge-large "24px-LargeDropdownLarge",
   DropdownLarge-small "16px-SmallDropdownLarge",
   DropdownLarge-xsmall "12px-XsmallDropdownLarge",
   DropdownSm-large "24px-LargeDropdownSm",
   DropdownSm-small "16px-SmallDropdownSm",
   DropdownSm-xsmall "12px-XsmallDropdownSm",
   Edit-large "24px-LargeEdit",
   Edit-small "16px-SmallEdit",
   Edit-xsmall "12px-XsmallEdit",
   EditColumns-large "24px-LargeEditColumns",
   EditColumns-small "16px-SmallEditColumns",
   EditColumns-xsmall "12px-XsmallEditColumns",
   Emoji-large "24px-LargeEmoji",
   Emoji-small "16px-SmallEmoji",
   Emoji-xsmall "12px-XsmallEmoji",
   Encrypted-large "24px-LargeEncrypted",
   Encrypted-small "16px-SmallEncrypted",
   Encrypted-xsmall "12px-XsmallEncrypted",
   Enlarge-large "24px-LargeEnlarge",
   Enlarge-small "16px-SmallEnlarge",
   Enlarge-xsmall "12px-XsmallEnlarge",
   Evaluate-large "24px-LargeEvaluate",
   Evaluate-small "16px-SmallEvaluate",
   Evaluate-xsmall "12px-XsmallEvaluate",
   EvaluatorComment-large "24px-LargeEvaluatorComment",
   EvaluatorComment-small "16px-SmallEvaluatorComment",
   EvaluatorComment-xsmall "12px-XsmallEvaluatorComment",
   Exit-large "24px-LargeExit",
   Exit-small "16px-SmallExit",
   Exit-xsmall "12px-XsmallExit",
   Facebook-large "24px-LargeFacebook",
   Facebook-small "16px-SmallFacebook",
   Facebook-xsmall "12px-XsmallFacebook",
   File-large "24px-LargeFile",
   File-small "16px-SmallFile",
   File-xsmall "12px-XsmallFile",
   FileCopies-large "24px-LargeFileCopies",
   FileCopies-small "16px-SmallFileCopies",
   FileCopies-xsmall "12px-XsmallFileCopies",
   Filter-large "24px-LargeFilter",
   Filter-small "16px-SmallFilter",
   Filter-xsmall "12px-XsmallFilter",
   FitHeight-large "24px-LargeFitHeight",
   FitHeight-small "16px-SmallFitHeight",
   FitHeight-xsmall "12px-XsmallFitHeight",
   FitScreen-large "24px-LargeFitScreen",
   FitScreen-small "16px-SmallFitScreen",
   FitScreen-xsmall "12px-XsmallFitScreen",
   FitWidth-large "24px-LargeFitWidth",
   FitWidth-small "16px-SmallFitWidth",
   FitWidth-xsmall "12px-XsmallFitWidth",
   Flag-large "24px-LargeFlag",
   Flag-small "16px-SmallFlag",
   Flag-xsmall "12px-XsmallFlag",
   Form-large "24px-LargeForm",
   Form-small "16px-SmallForm",
   Form-xsmall "12px-XsmallForm",
   Formula-large "24px-LargeFormula",
   Formula-small "16px-SmallFormula",
   Formula-xsmall "12px-XsmallFormula",
   Funnel-large "24px-LargeFunnel",
   Funnel-small "16px-SmallFunnel",
   Funnel-xsmall "12px-XsmallFunnel",
   Google-large "24px-LargeGoogle",
   Google-small "16px-SmallGoogle",
   Google-xsmall "12px-XsmallGoogle",
   GraphCurve-large "24px-LargeGraphCurve",
   GraphCurve-small "16px-SmallGraphCurve",
   GraphCurve-xsmall "12px-XsmallGraphCurve",
   Grid-large "24px-LargeGrid",
   Grid-small "16px-SmallGrid",
   Grid-xsmall "12px-XsmallGrid",
   Group-large "24px-LargeGroup",
   Group-small "16px-SmallGroup",
   Group-xsmall "12px-XsmallGroup",
   Grow-large "24px-LargeGrow",
   Grow-small "16px-SmallGrow",
   Grow-xsmall "12px-XsmallGrow",
   Hamburger-large "24px-LargeHamburger",
   Hamburger-small "16px-SmallHamburger",
   Hamburger-xsmall "12px-XsmallHamburger",
   Heading1-large "24px-LargeHeading1",
   Heading1-small "16px-SmallHeading1",
   Heading1-xsmall "12px-XsmallHeading1",
   Heading2-large "24px-LargeHeading2",
   Heading2-small "16px-SmallHeading2",
   Heading2-xsmall "12px-XsmallHeading2",
   Heading3-large "24px-LargeHeading3",
   Heading3-small "16px-SmallHeading3",
   Heading3-xsmall "12px-XsmallHeading3",
   Heading4-large "24px-LargeHeading4",
   Heading4-small "16px-SmallHeading4",
   Heading4-xsmall "12px-XsmallHeading4",
   Heading5-large "24px-LargeHeading5",
   Heading5-small "16px-SmallHeading5",
   Heading5-xsmall "12px-XsmallHeading5",
   Heading6-large "24px-LargeHeading6",
   Heading6-small "16px-SmallHeading6",
   Heading6-xsmall "12px-XsmallHeading6",
   Heart-large "24px-LargeHeart",
   Heart-small "16px-SmallHeart",
   Heart-xsmall "12px-XsmallHeart",
   Heatmap-large "24px-LargeHeatmap",
   Heatmap-small "16px-SmallHeatmap",
   Heatmap-xsmall "12px-XsmallHeatmap",
   HelpCenter-large "24px-LargeHelpCenter",
   HelpCenter-small "16px-SmallHelpCenter",
   HelpCenter-xsmall "12px-XsmallHelpCenter",
   Hierarchy-large "24px-LargeHierarchy",
   Hierarchy-small "16px-SmallHierarchy",
   Hierarchy-xsmall "12px-XsmallHierarchy",
   Home-large "24px-LargeHome",
   Home-small "16px-SmallHome",
   Home-xsmall "12px-XsmallHome",
   Hub-large "24px-LargeHub",
   Hub-small "16px-SmallHub",
   Hub-xsmall "12px-XsmallHub",
   Image-large "24px-LargeImage",
   Image-small "16px-SmallImage",
   Image-xsmall "12px-XsmallImage",
   ImageAlignCenter-large "24px-LargeImageAlignCenter",
   ImageAlignLeft-large "24px-LargeImageAlignLeft",
   ImageAlignRight-large "24px-LargeImageAlignRight",
   ImageCaption-large "24px-LargeImageCaption",
   ImageCaption-small "16px-SmallImageCaption",
   ImageCaption-xsmall "12px-XsmallImageCaption",
   ImageCenter-small "16px-SmallImageCenter",
   ImageCenter-xsmall "12px-XsmallImageCenter",
   ImageLeft-small "16px-SmallImageLeft",
   ImageLeft-xsmall "12px-XsmallImageLeft",
   ImageRight-small "16px-SmallImageRight",
   ImageRight-xsmall "12px-XsmallImageRight",
   ImproveWriting-large "24px-LargeImproveWriting",
   ImproveWriting-small "16px-SmallImproveWriting",
   ImproveWriting-xsmall "12px-XsmallImproveWriting",
   Inbox-large "24px-LargeInbox",
   Inbox-small "16px-SmallInbox",
   Inbox-xsmall "12px-XsmallInbox",
   InfiniteLoop-large "24px-LargeInfiniteLoop",
   InfiniteLoop-small "16px-SmallInfiniteLoop",
   InfiniteLoop-xsmall "12px-XsmallInfiniteLoop",
   Info-large "24px-LargeInfo",
   Info-small "16px-SmallInfo",
   Info-xsmall "12px-XsmallInfo",
   Job-large "24px-LargeJob",
   Job-small "16px-SmallJob",
   Job-xsmall "12px-XsmallJob",
   Kanban-large "24px-LargeKanban",
   Kanban-small "16px-SmallKanban",
   Kanban-xsmall "12px-XsmallKanban",
   Key-large "24px-LargeKey",
   Key-small "16px-SmallKey",
   Key-xsmall "12px-XsmallKey",
   LeftPanelClose-large "24px-LargeLeftPanelClose",
   LeftPanelClose-small "16px-SmallLeftPanelClose",
   LeftPanelClose-xsmall "12px-XsmallLeftPanelClose",
   LeftPanelOpen-large "24px-LargeLeftPanelOpen",
   LeftPanelOpen-small "16px-SmallLeftPanelOpen",
   LeftPanelOpen-xsmall "12px-XsmallLeftPanelOpen",
   Lightbulb-large "24px-LargeLightbulb",
   Lightbulb-small "16px-SmallLightbulb",
   Lightbulb-xsmall "12px-XsmallLightbulb",
   Like-large "24px-LargeLike",
   Like-small "16px-SmallLike",
   Like-xsmall "12px-XsmallLike",
   LinearScale-large "24px-LargeLinearScale",
   LinearScale-small "16px-SmallLinearScale",
   LinearScale-xsmall "12px-XsmallLinearScale",
   Link-large "24px-LargeLink",
   Link-small "16px-SmallLink",
   Link-xsmall "12px-XsmallLink",
   LinkedIn-large "24px-LargeLinkedIn",
   LinkedIn-small "16px-SmallLinkedIn",
   LinkedIn-xsmall "12px-XsmallLinkedIn",
   ListAltCheck-large "24px-LargeListAltCheck",
   ListAltCheck-small "16px-SmallListAltCheck",
   ListAltCheck-xsmall "12px-XsmallListAltCheck",
   ListBullets-large "24px-LargeListBullets",
   ListBullets-small "16px-SmallListBullets",
   ListBullets-xsmall "12px-XsmallListBullets",
   ListNumbered-large "24px-LargeListNumbered",
   ListNumbered-small "16px-SmallListNumbered",
   ListNumbered-xsmall "12px-XsmallListNumbered",
   ListView-large "24px-LargeListView",
   ListView-small "16px-SmallListView",
   ListView-xsmall "12px-XsmallListView",
   Loading-large "24px-LargeLoading",
   Loading-small "16px-SmallLoading",
   Loading-xsmall "12px-XsmallLoading",
   Location-large "24px-LargeLocation",
   Location-small "16px-SmallLocation",
   Location-xsmall "12px-XsmallLocation",
   LockLocked-large "24px-LargeLockLocked",
   LockLocked-small "16px-SmallLockLocked",
   LockLocked-xsmall "12px-XsmallLockLocked",
   LockUnlocked-large "24px-LargeLockUnlocked",
   LockUnlocked-small "16px-SmallLockUnlocked",
   LockUnlocked-xsmall "12px-XsmallLockUnlocked",
   Logout-large "24px-LargeLogout",
   Logout-small "16px-SmallLogout",
   Logout-xsmall "12px-XsmallLogout",
   ManageSearch-large "24px-LargeManageSearch",
   ManageSearch-small "16px-SmallManageSearch",
   ManageSearch-xsmall "12px-XsmallManageSearch",
   MenuBook-large "24px-LargeMenuBook",
   MenuBook-small "16px-SmallMenuBook",
   MenuBook-xsmall "12px-XsmallMenuBook",
   Messages-large "24px-LargeMessages",
   Messages-small "16px-SmallMessages",
   Messages-xsmall "12px-XsmallMessages",
   Mic-large "24px-LargeMic",
   Mic-small "16px-SmallMic",
   Mic-xsmall "12px-XsmallMic",
   MicOff-large "24px-LargeMicOff",
   MicOff-small "16px-SmallMicOff",
   MicOff-xsmall "12px-XsmallMicOff",
   Minus-large "24px-LargeMinus",
   Minus-small "16px-SmallMinus",
   Minus-xsmall "12px-XsmallMinus",
   Mobile-large "24px-LargeMobile",
   Mobile-small "16px-SmallMobile",
   Mobile-xsmall "12px-XsmallMobile",
   More-large "24px-LargeMore",
   More-small "16px-SmallMore",
   More-xsmall "12px-XsmallMore",
   MoveDown-large "24px-LargeMoveDown",
   MoveDown-small "16px-SmallMoveDown",
   MoveDown-xsmall "12px-XsmallMoveDown",
   NetworkConnection-large "24px-LargeNetworkConnection",
   NetworkConnection-small "16px-SmallNetworkConnection",
   NetworkConnection-xsmall "12px-XsmallNetworkConnection",
   NewsMode-large "24px-LargeNewsMode",
   NewsMode-small "16px-SmallNewsMode",
   NewsMode-xsmall "12px-XsmallNewsMode",
   Note-large "24px-LargeNote",
   Note-small "16px-SmallNote",
   Note-xsmall "12px-XsmallNote",
   NotificationsOff-large "24px-LargeNotificationsOff",
   NotificationsOff-small "16px-SmallNotificationsOff",
   NotificationsOff-xsmall "12px-XsmallNotificationsOff",
   NotificationsOn-large "24px-LargeNotificationsOn",
   NotificationsOn-small "16px-SmallNotificationsOn",
   NotificationsOn-xsmall "12px-XsmallNotificationsOn",
   Number-large "24px-LargeNumber",
   Number-small "16px-SmallNumber",
   Number-xsmall "12px-XsmallNumber",
   Open-large "24px-LargeOpen",
   Open-small "16px-SmallOpen",
   Open-xsmall "12px-XsmallOpen",
   OpenInFull-large "24px-LargeOpenInFull",
   OpenInFull-small "16px-SmallOpenInFull",
   OpenInFull-xsmall "12px-XsmallOpenInFull",
   Order-large "24px-LargeOrder",
   Order-small "16px-SmallOrder",
   Order-xsmall "12px-XsmallOrder",
   Passkey-large "24px-LargePasskey",
   Passkey-small "16px-SmallPasskey",
   Passkey-xsmall "12px-XsmallPasskey",
   PictureInPictureAlt-large "24px-LargePictureInPictureAlt",
   PictureInPictureAlt-small "16px-SmallPictureInPictureAlt",
   PictureInPictureAlt-xsmall "12px-XsmallPictureInPictureAlt",
   Pin-large "24px-LargePin",
   Pin-small "16px-SmallPin",
   Pin-xsmall "12px-XsmallPin",
   Platform-large "24px-LargePlatform",
   Platform-small "16px-SmallPlatform",
   Platform-xsmall "12px-XsmallPlatform",
   Play-large "24px-LargePlay",
   Play-small "16px-SmallPlay",
   Play-xsmall "12px-XsmallPlay",
   Plus-large "24px-LargePlus",
   Plus-small "16px-SmallPlus",
   Plus-xsmall "12px-XsmallPlus",
   PlusThin-large "24px-LargePlusThin",
   PlusThin-xsmall "12px-XsmallPlusThin",
   Post-large "24px-LargePost",
   Post-small "16px-SmallPost",
   Post-xsmall "12px-XsmallPost",
   Post2-large "24px-LargePost2",
   Post2-small "16px-SmallPost2",
   Post2-xsmall "12px-XsmallPost2",
   Preference-large "24px-LargePreference",
   Preference-small "16px-SmallPreference",
   Preference-xsmall "12px-XsmallPreference",
   Preview-large "24px-LargePreview",
   Preview-small "16px-SmallPreview",
   Preview-xsmall "12px-XsmallPreview",
   Print-large "24px-LargePrint",
   Print-small "16px-SmallPrint",
   Print-xsmall "12px-XsmallPrint",
   Process-large "24px-LargeProcess",
   Process-small "16px-SmallProcess",
   Process-xsmall "12px-XsmallProcess",
   ProcessLong-large "24px-LargeProcessLong",
   ProcessLong-small "16px-SmallProcessLong",
   ProcessLong-xsmall "12px-XsmallProcessLong",
   Question-large "24px-LargeQuestion",
   Question-small "16px-SmallQuestion",
   Question-xsmall "12px-XsmallQuestion",
   Redo-large "24px-LargeRedo",
   Redo-small "16px-SmallRedo",
   Redo-xsmall "12px-XsmallRedo",
   Refresh-large "24px-LargeRefresh",
   Refresh-small "16px-SmallRefresh",
   Refresh-xsmall "12px-XsmallRefresh",
   Remove-large "24px-LargeRemove",
   Remove-small "16px-SmallRemove",
   Remove-xsmall "12px-XsmallRemove",
   RemoveMinus-large "24px-LargeRemoveMinus",
   RemoveMinus-small "16px-SmallRemoveMinus",
   RemoveMinus-xsmall "12px-XsmallRemoveMinus",
   Reply-large "24px-LargeReply",
   Reply-small "16px-SmallReply",
   Reply-xsmall "12px-XsmallReply",
   ResizeWindow-large "24px-LargeResizeWindow",
   ResizeWindow-small "16px-SmallResizeWindow",
   ResizeWindow-xsmall "12px-XsmallResizeWindow",
   Return-large "24px-LargeReturn",
   Return-small "16px-SmallReturn",
   Return-xsmall "12px-XsmallReturn",
   RocketLaunch-large "24px-LargeRocketLaunch",
   RocketLaunch-small "16px-SmallRocketLaunch",
   RocketLaunch-xsmall "12px-XsmallRocketLaunch",
   Search-large "24px-LargeSearch",
   Search-small "16px-SmallSearch",
   Search-xsmall "12px-XsmallSearch",
   Security-large "24px-LargeSecurity",
   Security-small "16px-SmallSecurity",
   Security-xsmall "12px-XsmallSecurity",
   SemanticError-large "24px-LargeSemanticError",
   SemanticError-small "16px-SmallSemanticError",
   SemanticError-xsmall "12px-XsmallSemanticError",
   SemanticHelp-large "24px-LargeSemanticHelp",
   SemanticHelp-small "16px-SmallSemanticHelp",
   SemanticHelp-xsmall "12px-XsmallSemanticHelp",
   SemanticWarning-large "24px-LargeSemanticWarning",
   SemanticWarning-small "16px-SmallSemanticWarning",
   SemanticWarning-xsmall "12px-XsmallSemanticWarning",
   Send-large "24px-LargeSend",
   Send-small "16px-SmallSend",
   Send-xsmall "12px-XsmallSend",
   Settings-large "24px-LargeSettings",
   Settings-small "16px-SmallSettings",
   Settings-xsmall "12px-XsmallSettings",
   Share-large "24px-LargeShare",
   Share-small "16px-SmallShare",
   Share-xsmall "12px-XsmallShare",
   ShortText-large "24px-LargeShortText",
   ShortText-small "16px-SmallShortText",
   ShortText-xsmall "12px-XsmallShortText",
   Shortcut-large "24px-LargeShortcut",
   Shortcut-small "16px-SmallShortcut",
   Shortcut-xsmall "12px-XsmallShortcut",
   SideNavigation-large "24px-LargeSideNavigation",
   SideNavigation-small "16px-SmallSideNavigation",
   SideNavigation-xsmall "12px-XsmallSideNavigation",
   Slider-large "24px-LargeSlider",
   Slider-small "16px-SmallSlider",
   Slider-xsmall "12px-XsmallSlider",
   Sort-large "24px-LargeSort",
   Sort-small "16px-SmallSort",
   Sort-xsmall "12px-XsmallSort",
   SortAsc-small "16px-SmallSortAsc",
   SortDesc-small "16px-SmallSortDesc",
   Stage-large "24px-LargeStage",
   Stage-small "16px-SmallStage",
   Stage-xsmall "12px-XsmallStage",
   Star-large "24px-LargeStar",
   Star-small "16px-SmallStar",
   Star-xsmall "12px-XsmallStar",
   Steppers-large "24px-LargeSteppers",
   Steppers-small "16px-SmallSteppers",
   Steppers-xsmall "12px-XsmallSteppers",
   Stop-large "24px-LargeStop",
   Stop-small "16px-SmallStop",
   Stop-xsmall "12px-XsmallStop",
   SubmissionForm-large "24px-LargeSubmissionForm",
   SubmissionForm-small "16px-SmallSubmissionForm",
   SubmissionForm-xsmall "12px-XsmallSubmissionForm",
   Summarize-large "24px-LargeSummarize",
   Summarize-small "16px-SmallSummarize",
   Summarize-xsmall "12px-XsmallSummarize",
   Switch-large "24px-LargeSwitch",
   Switch-small "16px-SmallSwitch",
   Switch-xsmall "12px-XsmallSwitch",
   SwitchOn-large "24px-LargeSwitchOn",
   SwitchOn-small "16px-SmallSwitchOn",
   SwitchOn-xsmall "12px-XsmallSwitchOn",
   Table-large "24px-LargeTable",
   Table-small "16px-SmallTable",
   Table-xsmall "12px-XsmallTable",
   TableChart-large "24px-LargeTableChart",
   TableChart-small "16px-SmallTableChart",
   TableChart-xsmall "12px-XsmallTableChart",
   Tags-large "24px-LargeTags",
   Tags-small "16px-SmallTags",
   Tags-xsmall "12px-XsmallTags",
   Target-large "24px-LargeTarget",
   Target-small "16px-SmallTarget",
   Target-xsmall "12px-XsmallTarget",
   Team-large "24px-LargeTeam",
   Team-small "16px-SmallTeam",
   Team-xsmall "12px-XsmallTeam",
   TextCompare-large "24px-LargeTextCompare",
   TextCompare-small "16px-SmallTextCompare",
   TextCompare-xsmall "12px-XsmallTextCompare",
   TextSize-large "24px-LargeTextSize",
   TextSize-small "16px-SmallTextSize",
   TextSize-xsmall "12px-XsmallTextSize",
   TextStyleBold-large "24px-LargeTextStyleBold",
   TextStyleBold-small "16px-SmallTextStyleBold",
   TextStyleBold-xsmall "12px-XsmallTextStyleBold",
   TextStyleItalic-large "24px-LargeTextStyleItalic",
   TextStyleItalic-small "16px-SmallTextStyleItalic",
   TextStyleItalic-xsmall "12px-XsmallTextStyleItalic",
   TextStyleUnderline-large "24px-LargeTextStyleUnderline",
   TextStyleUnderline-small "16px-SmallTextStyleUnderline",
   TextStyleUnderline-xsmall "12px-XsmallTextStyleUnderline",
   Tie-large "24px-LargeTie",
   Tie-small "16px-SmallTie",
   Tie-xsmall "12px-XsmallTie",
   Timeline-large "24px-LargeTimeline",
   Timeline-small "16px-SmallTimeline",
   Timeline-xsmall "12px-XsmallTimeline",
   Title-large "24px-LargeTitle",
   Title-small "16px-SmallTitle",
   Title-xsmall "12px-XsmallTitle",
   Translation-large "24px-LargeTranslation",
   Translation-small "16px-SmallTranslation",
   Translation-xsmall "12px-XsmallTranslation",
   Trophy-large "24px-LargeTrophy",
   Trophy-small "16px-SmallTrophy",
   Trophy-xsmall "12px-XsmallTrophy",
   URL-large "24px-LargeURL",
   URL-small "16px-SmallURL",
   URL-xsmall "12px-XsmallURL",
   Undo-large "24px-LargeUndo",
   Undo-small "16px-SmallUndo",
   Undo-xsmall "12px-XsmallUndo",
   Undo2-large "24px-LargeUndo2",
   Undo2-small "16px-SmallUndo2",
   Undo2-xsmall "12px-XsmallUndo2",
   Unlink-large "24px-LargeUnlink",
   Unlink-small "16px-SmallUnlink",
   Unlink-xsmall "12px-XsmallUnlink",
   Update-large "24px-LargeUpdate",
   Update-small "16px-SmallUpdate",
   Update-xsmall "12px-XsmallUpdate",
   Upload-large "24px-LargeUpload",
   Upload-small "16px-SmallUpload",
   Upload-xsmall "12px-XsmallUpload",
   UploadCloud-large "24px-LargeUploadCloud",
   UploadCloud-small "16px-SmallUploadCloud",
   UploadCloud-xsmall "12px-XsmallUploadCloud",
   UserBadge-large "24px-LargeUserBadge",
   UserBadge-small "16px-SmallUserBadge",
   UserBadge-xsmall "12px-XsmallUserBadge",
   UserLabel-large "24px-LargeUserLabel",
   UserLabel-small "16px-SmallUserLabel",
   UserLabel-xsmall "12px-XsmallUserLabel",
   UserMultiple-large "24px-LargeUserMultiple",
   UserMultiple-small "16px-SmallUserMultiple",
   UserMultiple-xsmall "12px-XsmallUserMultiple",
   UserProfile-large "24px-LargeUserProfile",
   UserSingle-large "24px-LargeUserSingle",
   UserSingle-small "16px-SmallUserSingle",
   UserSingle-xsmall "12px-XsmallUserSingle",
   Video-large "24px-LargeVideo",
   Video-small "16px-SmallVideo",
   Video-xsmall "12px-XsmallVideo",
   ViewHide-large "24px-LargeViewHide",
   ViewHide-small "16px-SmallViewHide",
   ViewHide-xsmall "12px-XsmallViewHide",
   ViewModule-large "24px-LargeViewModule",
   ViewModule-small "16px-SmallViewModule",
   ViewModule-xsmall "12px-XsmallViewModule",
   ViewShow-large "24px-LargeViewShow",
   ViewShow-small "16px-SmallViewShow",
   ViewShow-xsmall "12px-XsmallViewShow",
   WrapText-large "24px-LargeWrapText",
   WrapText-small "16px-SmallWrapText",
   WrapText-xsmall "12px-XsmallWrapText",
   ZoomIn-large "24px-LargeZoomIn",
   ZoomIn-small "16px-SmallZoomIn",
   ZoomIn-xsmall "12px-XsmallZoomIn",
   ZoomOut-large "24px-LargeZoomOut",
   ZoomOut-small "16px-SmallZoomOut",
   ZoomOut-xsmall "12px-XsmallZoomOut"})
